export class Response {

    success: boolean;
    status: string;
    exception: string;
    customException: string;
    customResultId: number;

}